import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { DistributionHistory } from './distributionHistory';

export const featureToggleMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('name', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride('randomHouseholdDistributions', {
    _component: () => DistributionHistory,
  }, overrideReadOnly);
